export default __webpack_public_path__ + "static/media/Ironman_04.ffd1e374.png";